var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M16.8555 1H4.85547C3.75547 1 2.85547 1.9 2.85547 3V17H4.85547V3H16.8555V1ZM19.8555 5H8.85547C7.75547 5 6.85547 5.9 6.85547 7V21C6.85547 22.1 7.75547 23 8.85547 23H19.8555C20.9555 23 21.8555 22.1 21.8555 21V7C21.8555 5.9 20.9555 5 19.8555 5ZM19.8555 21H8.85547V7H19.8555V21Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
